// eslint-disable-next-line import/no-extraneous-dependencies
import Swiper from 'swiper/bundle';

const myplanRecommendSpotList = document.querySelector('[data-role="myplan-recommend-spot-swiper"]');
if (myplanRecommendSpotList !== null) {
  const slides = myplanRecommendSpotList.querySelectorAll('.swiper-slide');
  const slideCount = slides.length;
  const slidesPerView = window.innerWidth >= 1024 ? 4 : 1;
  const loopEnabled = slideCount > slidesPerView;
  // eslint-disable-next-line no-new
  let myplanRecommendSpotSwiper = new Swiper(myplanRecommendSpotList, {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: loopEnabled,
    centeredSlides: true,
    centerInsufficientSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 750,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
    navigation: {
      nextEl: myplanRecommendSpotList.querySelector('[data-role="myplan-recommend-spot-swiper-nav-next"]'),
      prevEl: myplanRecommendSpotList.querySelector('[data-role="myplan-recommend-spot-swiper-nav-prev"]'),
    },
    on: {
      init: function () {
        const prevBtn = myplanRecommendSpotList.querySelector('[data-role="myplan-recommend-spot-swiper-nav-prev"]');
        const nextBtn = myplanRecommendSpotList.querySelector('[data-role="myplan-recommend-spot-swiper-nav-next"]');

        if (!loopEnabled) {
          prevBtn.classList.add('is-disabled');
          nextBtn.classList.add('is-disabled');
        } else {
          prevBtn.classList.remove('is-disabled');
          nextBtn.classList.remove('is-disabled');
        }
      },
    },
  });
}